export interface SnackbarModelInterface {
  position: string;
  timeout: number;
  text: string;
  color: string;
}

export class SnackbarModel implements SnackbarModelInterface {
  color: string;
  position: string;
  text: string;
  timeout: number;
  constructor(text: string, color = "success", position = "bottom", timeout = 1000) {
    this.color = color;
    this.text = text;
    this.position = position;
    this.timeout = timeout;
  }
}
